"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var BaselineAggregationConverter_1 = require("./conversions/BaselineAggregationConverter");

var BaselineAggregationConverterImpl_1 = require("./conversions/BaselineAggregationConverterImpl");

var BaselineConverter_1 = require("./conversions/BaselineConverter");

var BaselineConverterImpl_1 = require("./conversions/BaselineConverterImpl");

var BaselineInfoConverter_1 = require("./conversions/BaselineInfoConverter");

var BaselineInfoConverterImpl_1 = require("./conversions/BaselineInfoConverterImpl");

var PromoBaselineOutputConverter_1 = require("./conversions/PromoBaselineOutputConverter");

var PromoBaselineOutputConverterImpl_1 = require("./conversions/PromoBaselineOutputConverterImpl");

var PromoRegularVolumeOutputConverter_1 = require("./conversions/PromoRegularVolumeOutputConverter");

var PromoRegularVolumeOutputConverterImpl_1 = require("./conversions/PromoRegularVolumeOutputConverterImpl");

var ZeroBaselineConverter_1 = require("./conversions/ZeroBaselineConverter");

var ZeroBaselineConverterImpl_1 = require("./conversions/ZeroBaselineConverterImpl");
/**
 * @author Adam Drda
 */


var BaselineAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(BaselineAppModule, _AppModule_1$AppModul);

  function BaselineAppModule() {
    var _this;

    _classCallCheck(this, BaselineAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaselineAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'baselineAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(BaselineAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(BaselineConverter_1.BaselineConverter).to(BaselineConverterImpl_1.BaselineConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ZeroBaselineConverter_1.ZeroBaselineConverter).to(ZeroBaselineConverterImpl_1.ZeroBaselineConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(BaselineInfoConverter_1.BaselineInfoConverter).to(BaselineInfoConverterImpl_1.BaselineInfoConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromoBaselineOutputConverter_1.PromoBaselineOutputConverter).to(PromoBaselineOutputConverterImpl_1.PromoBaselineOutputConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromoRegularVolumeOutputConverter_1.PromoRegularVolumeOutputConverter).to(PromoRegularVolumeOutputConverterImpl_1.PromoRegularVolumeOutputConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(BaselineAggregationConverter_1.BaselineAggregationConverter).to(BaselineAggregationConverterImpl_1.BaselineAggregationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromoRegularVolumeOutputConverter_1.PromoRegularVolumeOutputConverter).to(PromoRegularVolumeOutputConverterImpl_1.PromoRegularVolumeOutputConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return BaselineAppModule;
}(AppModule_1.AppModule);

exports.BaselineAppModule = BaselineAppModule;